import { createGlobalStyle } from 'styled-components';

// ----------------------------------------------------------------------

const GlobalStyles = createGlobalStyle`

  *, :after, :before {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body, #root {
    width: 100%;
    height: 100%;
    color: ${({theme}) => theme.colors.grayscale[600]};
    font-size: 14px;
    font-family: Pretendard, sans-serif;
    background-color: #F7F8FA;
  }

  ul, li {
    list-style: none;
  }

  a {
    text-decoration: none;
    color: ${({theme}) => theme.colors.grayscale[500]};
  }

  form {
    > div:not(:first-child) {
      margin-top: 10px;
    }
    > button {
      width: 100%;
    }
  }

  input, button, select, textarea {
    font-size: inherit;
    font-family: inherit;
    background-color: transparent;
    color: ${({theme}) => theme.colors.grayscale[500]};
  }
  
  input, select {
    height: 40px;
    background-color: #FFFFFF;
  }

  input:disabled {
    background-color: ${({theme}) => theme.colors.grayscale[50]};
    color: ${({theme}) => theme.colors.grayscale[400]};
  }

  input::placeholder {
    color: ${({theme}) => theme.colors.grayscale[400]};
  }

  input:focus, select:focus {
    outline: none;
  }

  input:-webkit-autofill, input:-webkit-autofill:focus {
    box-shadow: 0 0 0 1000px #FFFFFF inset;
    -webkit-box-shadow: 0 0 0 1000px #FFFFFF inset;
    text-fill-color: ${({theme}) => theme.colors.grayscale[500]};
	  -webkit-text-fill-color: ${({theme}) => theme.colors.grayscale[500]};
  }

  input:-webkit-autofill:disabled {
    box-shadow: 0 0 0 1000px ${({theme}) => theme.colors.grayscale[50]} inset;
    -webkit-box-shadow: 0 0 0 1000px ${({theme}) => theme.colors.grayscale[50]} inset;
    text-fill-color: ${({theme}) => theme.colors.grayscale[400]};
	  -webkit-text-fill-color: ${({theme}) => theme.colors.grayscale[400]};
  }

  input[type='checkbox'] {
    display: none;
  }
  input[type='checkbox'] + label {
    display: block;
    width: 20px;
    height: 20px;
    border: 1px solid ${({theme}) => theme.colors.grayscale[200]};
    border-radius: 3px;
    background-color: #FFFFFF;
  }
  input[type='checkbox']:checked + label{
    background-image: url(/assets/form/check.svg);
    background-size: 22px 22px;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: ${({theme}) => theme.colors.primary[400]};
    border: none;
  }

  input[type='radio'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border: 1px solid ${({theme}) => theme.colors.grayscale[200]};
    border-radius: 50%;
    background-color: #FFFFFF;
    margin: 1px;
  }
  input[type='radio']:checked {
    background-color: ${({theme}) => theme.colors.primary[400]};
    border: 4px solid #FFFFFF;
    box-shadow: 0 0 0 1px ${({theme}) => theme.colors.grayscale[200]};
  }
  input[type='radio']:disabled {
    background-color: #FFFFFF;
    box-shadow: none;
    border: 6px solid ${({theme}) => theme.colors.grayscale[200]}66;
  }
  
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 8px;
    border: 1px solid ${({theme}) => theme.colors.grayscale[200]};
    background-image: url(/assets/base/chevron.svg);
    background-size: 24px 24px;
    background-position: right 20px center;
    background-repeat: no-repeat;
    padding: 0 54px 0 20px;
    text-align: left;
  }
  select::-ms-expand {
    display: none;
  }
  
  button {
    cursor: pointer;
    border: none;
    height: 40px;
  }
  
  button:disabled {
    cursor: default;
  }

  td {
    text-align: center;

    > button {
      text-decoration: underline;
    }

    label {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export default GlobalStyles;